import { useRef } from 'react'

import classNames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from '@lingui/macro'
import Button from 'Root/App/Button'

import styles from './index.module.css'

interface Props {
  pageNumber: number
  pageCount: number
  setPageNumberCallback: Function
}

const PdfSinglePageNavigation = ({
  pageNumber,
  pageCount,
  setPageNumberCallback,
}: Props) => {
  const pageNumberInputRef = useRef(null)

  const seekPage = (e) => {
    if (e.key === 'Enter') {
      const pageNumber = parseInt(e.target.value)
      if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= pageCount) {
        setPageNumberCallback(pageNumber)
      }
    }
  }

  const changePage = (offset) => {
    pageNumberInputRef.current.value = pageNumber + offset
    setPageNumberCallback((prevPageNumber) => prevPageNumber + offset)
  }

  const previousPage = () => changePage(-1)
  const nextPage = () => changePage(1)

  return (
    <div
      id="pdf-document-navigation"
      className="flex justify-between items-center pt-4"
    >
      <Button
        className={classNames([
          'bg-white ',
          pageNumber <= 1 ? 'text-gray-400 cursor-default' : 'text-gray-900',
        ])}
        subtype="circle"
        disabled={pageNumber <= 1}
        onClick={previousPage}
        icon={<FontAwesomeIcon icon={['fas', 'arrow-left']} />}
      />

      <div>
        <span className={styles['value-control']}>
          <input
            ref={pageNumberInputRef}
            type="number"
            defaultValue={pageNumber}
            onKeyDown={seekPage}
          />
        </span>

        <span>
          <Trans>di</Trans> {pageCount || '--'}
        </span>
      </div>

      <Button
        className={classNames([
          'bg-white ',
          pageNumber >= pageCount
            ? 'text-gray-400 cursor-default'
            : 'text-gray-900',
        ])}
        subtype="circle"
        disabled={pageNumber >= pageCount}
        onClick={nextPage}
        icon={<FontAwesomeIcon icon={['fas', 'arrow-right']} />}
      />
    </div>
  )
}

export default PdfSinglePageNavigation
